<template>
  <div class="about">
    <el-container >
      <!--左侧侧边栏-->
      <el-aside style="width: 200px;">
        <el-menu
          :default-active="1"
          :active="1"
          :router="true"
        >
          <el-menu-item index="1" route="/about/introduce">公司介绍</el-menu-item>
          <el-menu-item index="2" route="/about/events">成蹊动态</el-menu-item>
          <el-menu-item index="3" route="/about/partner">合作伙伴</el-menu-item>
          <el-menu-item index="4" route="/about/joinUs">加入我们</el-menu-item>
        </el-menu>
      </el-aside>
      <!--主要区域容器-->
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'about',
  data () {
    return {
      show: ['1']
    }
  }
}
</script>
